/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phase2_Fix_Public_Tool_VerificationInputs */

const en_phase2_fix_public_tool_verification = /** @type {(inputs: Phase2_Fix_Public_Tool_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification failed. Complete the check and try again.`)
};

const zh_hans1_phase2_fix_public_tool_verification = /** @type {(inputs: Phase2_Fix_Public_Tool_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证失败。请完成验证后重试。`)
};

const pt_br2_phase2_fix_public_tool_verification = /** @type {(inputs: Phase2_Fix_Public_Tool_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A verificação falhou. Conclua a verificação e tente de novo.`)
};

const es_phase2_fix_public_tool_verification = /** @type {(inputs: Phase2_Fix_Public_Tool_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La verificación falló. Completa la comprobación e inténtalo de nuevo.`)
};

const fr_phase2_fix_public_tool_verification = /** @type {(inputs: Phase2_Fix_Public_Tool_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La vérification a échoué. Terminez le contrôle et réessayez.`)
};

const de_phase2_fix_public_tool_verification = /** @type {(inputs: Phase2_Fix_Public_Tool_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Verifizierung ist fehlgeschlagen. Schließe die Prüfung ab und versuch es erneut.`)
};

const ru_phase2_fix_public_tool_verification = /** @type {(inputs: Phase2_Fix_Public_Tool_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверка не пройдена. Пройдите проверку и повторите попытку.`)
};

const it_phase2_fix_public_tool_verification = /** @type {(inputs: Phase2_Fix_Public_Tool_VerificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica non riuscita. Completa il controllo e riprova.`)
};

/**
* | output |
* | --- |
* | "Verification failed. Complete the check and try again." |
*
* @param {Phase2_Fix_Public_Tool_VerificationInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const phase2_fix_public_tool_verification = /** @type {((inputs?: Phase2_Fix_Public_Tool_VerificationInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phase2_Fix_Public_Tool_VerificationInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_phase2_fix_public_tool_verification(inputs)
	if (locale === "pt-BR") return pt_br2_phase2_fix_public_tool_verification(inputs)
	if (locale === "es") return es_phase2_fix_public_tool_verification(inputs)
	if (locale === "fr") return fr_phase2_fix_public_tool_verification(inputs)
	if (locale === "de") return de_phase2_fix_public_tool_verification(inputs)
	if (locale === "ru") return ru_phase2_fix_public_tool_verification(inputs)
	if (locale === "it") return it_phase2_fix_public_tool_verification(inputs)
	return en_phase2_fix_public_tool_verification(inputs)
});